<template>
    <div class="my-3">
        <!-- Usuário secundário criado  -->
        <base-input
            v-model="secondary.name"
            v-validate="'required'"
            :name="$t('login.name')"
            :placeholder="$t('login.name')"
            :error="errors.first($t('login.name'))"></base-input>
        <base-input
            v-model="secondary.email"
            :name="$t('login.email')"
            :placeholder="$t('login.email')"
            v-validate.disable="'required|email'"
            :error="errors.first($t('login.email'))"
            :disabled="!disabled"
        ></base-input>
        <template v-if="disabled || !secondary">
            <base-input
                v-model="secondary.password"
                :name="$t('login.password.title')"
                :placeholder="$t('login.password.title')"
                v-validate.disable="'required'"
                :error="errors.first($t('login.password.title'))"
                type="password"></base-input>
            <base-input
                v-model="secondary.password_confirmation"
                :name="$t('login.password.confirm')"
                :placeholder="$t('login.password.confirm')"
                v-validate.disable="{ is: secondary.password, required: true }"
                :error="errors.first($t('login.password.confirm'))"
                type="password"></base-input>
            <base-button
                block
                type="primary"
                @click="create">{{$t('profile.secondary.create')}}</base-button>
        </template>
        <template v-else>
            <div
                :class="blockStudentFields===0 ? 'd-flex flex-wrap justify-content-between mb-3' : 'd-flex flex-wrap justify-content-center mb-3'"
            >
                <div class="col-md-6 pl-0" :class="$mq === 'sm' ? 'pr-0 mb-2' : ''">
                    <base-button
                        class="col-12 mr-0"
                        block
                        :style="$bgColor(color.primary)"
                        @click="$emit('changePassword', secondary)">{{$t('login.password.change.title')}}</base-button>
                </div>
                <change-email
                    v-if="secondary.id && blockStudentFields===0"
                    class="col-md-6 pr-0"
                    :class="$mq === 'sm' ? 'pl-0 mb-2' : ''"
                    :color="color"
                    :user-id="secondary.id"
                    @updatedEmail="updateEmail"
                ></change-email>
            </div>
            <base-button
                block
                type="danger"
                @click="dialog = true">{{$t('profile.secondary.delete')}}</base-button>
        </template>
        <ConfirmDialog
            v-model="dialog"
            :title="$t('profile.secondary.delete')"
            :message="$t('profile.secondary.warning')"
            @action="remove"></ConfirmDialog>
    </div>
</template>

<script>
import BaseInput from '../../argon/components/Inputs/BaseInput'
import BaseButton from '../../argon/components/BaseButton'

import ConfirmDialog from '../Common/ConfirmationDialog'
import ChangeEmail from './ProfileChangeEmail'

export default {
    emits: ['changePassword', 'errors', 'input', 'removeSecondaryUser', 'update:modelValue'],
    name: 'ProfileSecondary',
    components: {
        BaseInput,
        BaseButton,
        ConfirmDialog,
        ChangeEmail
    },
    props: {
        modelValue: {
            type: Object,
            required: true
        },
        color: {
            type: Object,
            required: true
        },
        blockStudentFields: {
            type: Number
        }
    },
    data() {
        return {
            disabled: false,
            dialog: false,
            resetDialog: false
        }
    },
    watch: {
        errorsBag(val) {
            this.$emit('errors', val)
        }
    },
    computed: {
        secondary: {
            get() {
                return this.modelValue
            },
            set(value) {
                this.$emit('update:modelValue', value);
                this.$emit('input', value);
            }
        },
        errorsBag() {
            return this.errors.items.length
        }
    },
    methods: {
        create() {
            this.$validator.validate().then(valid => {
                if (valid) {
                    this.$loading.show()

                    window.axios.post('/api/app/profile/user', {
                            ...this.secondary,
                            language: localStorage.getItem('lang')
                        })
                        .then(res => {
                            this.$notify({ type: 'success', message: res.data.message })
                            this.secondary.id = res.data.user
                            this.disabled = false
                        })
                        .catch(err =>
                            this.$notify({
                                type: 'danger',
                                message: (err.response.data.errors && err.response.data.errors[0])
                                    || err.response.data.error
                            })
                        )
                        .finally(() => {
                            this.$loading.close()
                        })
                }
            })
        },
        disablePasswordFields() {
            if (Object.keys(this.secondary).length <= 0) return this.disabled = true
        },
        remove() {
            this.$loading.show()

            window.axios.delete('/api/app/profile/user')
                .then(res => {
                    this.$notify({
                        type: 'success',
                        message: res.data.message
                    })
                    this.secondary = {}
                    this.dialog = false
                    this.disabled = true;
                })
                .catch(err => this.$notify({
                    type: 'danger',
                    message: err.response.data.error
                }))
                .finally(() => {
                    this.$loading.close()
                    this.$emit('removeSecondaryUser', this.secondary.id)
                })
        },
        updateEmail(email) {
            this.secondary.email = email
        }
    },
    mounted() {
        this.disablePasswordFields()
    },
    updated() {
        this.disablePasswordFields()
    }
}
</script>

<style>

</style>
